import React from 'react';

import Zoom from 'assets/images/icon/Zoom';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';
import {fadeIn} from "../../../../styled/StyledComponent";
import {dateUtil} from "../../../../util";
import EditIcon from "../../../../assets/images/icon/EditIcon";

const returnColor = (text) => {
    switch (text) {
        case "New": {
            return "#FFC8DD";
        }
        case "Completed": {
            return "#9AE3B7";
        }
        case "Received": {
            return "#B0CBFF";
        }
        default:
            break;
    }
};
const ReviewItem = (props) => {
    const returnData = (date) => {
        // const c = cloneDeep(date).map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };
    console.log("reData",props?.data);
    return (
        <Container>       
            <Thumb>
                <img src={"/images/homeworkImg.png"} alt="" />
            </Thumb>
            <ListMain>
                <CategoryList>
                    <Category
                        style={{
                            background: returnColor(props?.data?.completed === false ? "New" : "Completed"),
                        }}
                    >
                        {/* <span>{textTransform().capitalizeFirstLetter(String(props?.data?.communicationStep)?.toLocaleLowerCase())}</span> */}
                        <span>{props?.data?.completed === false ? "New" : "Completed"}</span>
                    </Category>
                    {false && (
                        <Category style={{ background: "#CECECD", color: "#333" }}>
                            <span>Hidden</span>
                        </Category>
                    )}
                </CategoryList>

                <h3>{props?.data?.title || props?.data?.content}</h3>
                <DateItem style={{ marginBottom: 10 }}>
                        <p className={"date"}>
                            {dateUtil.mainCardDateFormat(props?.data?.updatedDatetime || "2024-12-01")}
                        </p>
                    {/* <Instructor>
                        <p>
                          Instructor: <span>{props?.userData?.lastName} {props?.userData?.firstName}</span>
                        </p>
                    </Instructor> */}
                </DateItem>

                <User>{props?.data?.user?.nickName || "User name"}</User>
            </ListMain>
            <ListButton onClick={()=>{props.onClickPopup(props?.data)}}>
                <span>{props?.data?.completed === false ? "Reply" : "View"}</span>
                {props?.data?.completed === false ? (
                    <Zoom />
                ) : (
                    <EditIcon/>
                )}
            </ListButton>
        </Container>
    );
};
export default ReviewItem;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
`;

const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Container = styled.div`
    display: flex;
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`;
const Thumb = styled.div`
    background: #ddd;
    overflow: hidden;
    width: 113px;
    height: 113px;
    border-radius: 5px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    @media screen and (max-width: 768px) {
        h3{
            font-size: 20px!important;
        }
    }
    h3 {
        font-size: 26px;
        margin: 10px 0 9.6px 0;
    }
`;
const CategoryList = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
const Category = styled.div`
    padding: 7px 12px;
    margin-right: 15px;
    background: #f0a8a8;
    cursor: default;
    width: 85px;
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    font-weight: 700;
    span {
        text-transform: capitalize;
    }
`;
const DateItem = styled.div`
    display: flex;
    p {
        color: #33333385;
        &.date{
            
                font-family: "Source Serif 4", sans-serif;
                color: #333333;
                font-size: 14px;
                font-weight: 600;
                line-height: 14px;
                letter-spacing: 0em;
                text-align: left;
                opacity: 0.5;
        }
    }
    span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333ac;
    }
`;

const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    border: solid 1px #333;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    transition: all 0.2s;
    background: #333;
    width: 87px;
    height: 26px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        position: absolute;
        right: 0;
        height: 26px;
    }
    span {
        margin-right: 10px;
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;

const Instructor = styled.div`
    margin-left: 20px;
`;
const User = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #333333d2;
`;
